export enum AggregationType {
  NONE,
  VWAP,
  PART_AGG,
}

export namespace AggregationType {
  let elements = [AggregationType.NONE, AggregationType.VWAP, AggregationType.PART_AGG];
  let alias = "com.bcdfx.model.enums.AggregationType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
